import { Expose, Transform } from 'class-transformer';
import { IsUUID, IsInt } from 'class-validator';

export class UserStatsDto {
	@IsUUID()
	userId: string;

	@Expose()
	@Transform(({ value }) => (typeof value === 'string' ? parseInt(value, 10) : value))
	@IsInt()
	ticketsCount: number;

	@Expose()
	@Transform(({ value }) => (typeof value === 'string' ? parseInt(value, 10) : value))
	@IsInt()
	totalGMV: number;
}
